import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, ref } from 'vue';

interface ILedCalculatorProduct {
    normal: number;
    id: number;
    llmf: number;
    lumen: number;
    name: string;
    image: string;
    dimmed: number;
    type1_idx: number;
    type2_idx: number;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'BlockLedConfigurator',
  props: {
    model: { default: {
        products: [],
        ledProducts: []
    } }
  },
  setup(__props: any) {

const props = __props as { model: any }



const showTypeOne = ref<boolean>(false);
const showTypeTwo = ref<boolean>(false);
const selectedProduct = ref<ILedCalculatorProduct>();
const normalHours = ref<any>('4000');
const dimmedHours = ref<any>('2500');

onMounted(() => {
    selectedProduct.value = props.model.products[0];
});

const normalEffect = computed<number>(() => {
    if (valueIsNumber(normalHours.value)) {
        return (normalHours.value * (selectedProduct.value ? selectedProduct.value.normal : 0)) / 1000;
    }
    return 1;
});

const typeOne = computed<any>(() => selectedProduct.value != null ? props.model.ledProducts.find(x => x.id === selectedProduct.value.type1_idx) : null);
const typeTwo = computed<any>(() => selectedProduct.value != null ? props.model.ledProducts.find(x => x.id === selectedProduct.value.type2_idx) : null);
const normalDriftHours = computed<number>(() => normalHours.value - dimmedHours.value);

function yearlyEffect(subject: ILedCalculatorProduct): number {
    if (!subject) return 0;
    let defaultDimmedUnit:any = 0;
    if (dimmedHours.value !== '') {
        defaultDimmedUnit = parseInt(dimmedHours.value, 10);
    }
    return ((((normalDriftHours.value * subject.normal) + (defaultDimmedUnit * subject.dimmed)) / 1000) as any).toFixed(0);
}

function averageYearlySavings(subject: ILedCalculatorProduct): number {
    return ((((normalEffect.value - yearlyEffect(subject)) / normalEffect.value * 100)) as any).toFixed(0);
}

function valueIsNumber(value): boolean {
    // has value, value is not empty space and is a number
    return !!(value && value.trim() && parseInt(value, 10)) || value === '0';
}


return { __sfc: true,props, showTypeOne, showTypeTwo, selectedProduct, normalHours, dimmedHours, normalEffect, typeOne, typeTwo, normalDriftHours, yearlyEffect, averageYearlySavings, valueIsNumber }
}

})